export default {
    setBookings(state, bookings) {
        state.bookings = bookings;
    },
    setDailyValue(state, value) {
        state.dailyValue = value;
    },
    setDailySales(state, value) {
        state.dailySales = value;
    },
    setDailySalesBookings(state, value) {
        state.dailySalesBookings = value;
    },
    setActiveBooking(state, activeBooking) {
        state.activeBooking = activeBooking;
    },
    setManageBookingDialog(state, status) {
        state.manageBookingDialog = status;
    },
    setManageDeleteBookingDialog(state, status) {
        state.manageDeleteBookingDialog = status;
    },
    setPreviewJobDialog(state, status) {
        state.previewJobDialog = status;
    },
    setEntries(state, entries) {
        state.entries = entries;
    },
    setReschedule(state, bookings) {
        state.reschedule = bookings;
    },
    setCancellation(state, bookings) {
        state.cancellation = bookings;
    },
    setCumulative(state, data) {
        state.cumulative = data;
    }
}
